// src/pages/AuthorLanding.tsx
import { Link } from 'react-router-dom';
import { collection, getDocs, query, orderBy, where, Query, DocumentData } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../../services/firebase';
import { useState, useEffect } from 'react';
import { HorizontalRule } from '@mui/icons-material';
import { ListItemIcon } from '@mui/material';
import { SvgIcon } from '@mui/material';

interface DocumentItem {
  id: string;
  title: string;
  updatedAt?: any; // Firestore Timestamp
}

const pencilEditIcon = <svg
  className="w-4 h-4"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M12 20h9" />
  <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
</svg>;


const ViewLogoAssets = () => {
  const [documents, setDocuments] = useState<DocumentItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      {/* Header + Prominent New Document Button */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-10">
<h1 className="text-3xl font-bold text-gray-900 mb-6">Logo Assets</h1>

{/* <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"> */}
<ul className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
  {/* Favicon Icon */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/favicon.ico?v=2" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2">
        <img src="/favicons/favicon.ico?v=2" alt="Favicon" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">Favicon (.ico)</span>
    </a>
  </li>

  {/* Favicon 32x32 */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/favicon-32.png?v=2" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2">
        <img src="/favicons/favicon-32.png?v=2" alt="Favicon 32x32" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">Favicon (32x32)</span>
    </a>
  </li>

  {/* Apple Touch Icon */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/apple-touch-icon.png" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2">
        <img src="/favicons/apple-touch-icon.png" alt="Apple Touch Icon" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">Apple Touch Icon</span>
    </a>
  </li>

  {/* Android 192x192 */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/android-chrome-192x192.png" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2">
        <img src="/favicons/android-chrome-192x192.png" alt="Android 192x192" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">Android (192x192)</span>
    </a>
  </li>

  {/* Android 512x512 */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/android-chrome-512x512.png" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2">
        <img src="/favicons/android-chrome-512x512.png" alt="Android 512x512" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">Android (512x512)</span>
    </a>
  </li>

  {/* MS Tile */}
  <li className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
    <a href="/favicons/ms-icon-144x144.png" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 text-center group">
      <div className="w-16 h-16 flex items-center justify-center bg-white border rounded p-2" style={{ backgroundColor: '#8A7355' }}>
        <img src="/favicons/ms-icon-144x144.png" alt="MS Tile 144x144" className="max-w-full max-h-full object-contain" />
      </div>
      <span className="text-sm font-medium text-gray-700 group-hover:text-blue-600 break-all">MS Tile (144x144)</span>
    </a>
  </li>
</ul>
      </div>
    </div>
  );
};

export default ViewLogoAssets;